import { DOCUMENT } from '@angular/common';
import { Injectable, effect, inject, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutStateService {
  private readonly document = inject(DOCUMENT);

  readonly darkMode = signal(localStorage.getItem('theme')==='dark');

  constructor() {
    effect(() => {
      this.document.documentElement.classList.toggle('app-theme-dark', this.darkMode());
    });
  }

  toggleDarkMode(): void {
    this.darkMode.update((enabled) => !enabled);
    localStorage.setItem('theme', this.darkMode() ? 'dark' : 'light');
  }
}
